import { makeAutoObservable } from "mobx";
import commonStore from "../../Store/marco/commonStore";
import { dashboardAPI } from "../API/dashboardAPI";
import handleAPIError, {
  MESSAGE_CODES,
  showErrorToast,
  showSuccessToast,
} from "../../services/toast";
import { strToNum } from "../utils/strToNum";
import { formatNumber4Decimal } from "../utils/formatNumber4Decimal";
const API = dashboardAPI;
const cmStore = commonStore;

const getAllSelectableCompanyIds = (companyList) =>
  (Array.isArray(companyList) ? companyList : [])
    .filter(
      (item) =>
        item?.id &&
        item.nodeStatus !== "hidden" &&
        item.nodeStatus !== "readonly",
    )
    .map((item) => item.id);

class DashboardStore {
  ////////類別或是範疇
  groupBy = "scope";
  ////////選擇的公司
  selectedCom = [];

  ////////intensity 預設的公司
  defaultSelectedCom = [];

  ////////intensity 預設的AR
  defaultgwpId = 3;

  ////////選擇年份還是月份
  format = "yearly";
  selectedYear = "";
  selectedMonth = "";
  ////////AR5還是AR6
  gwpId = "3";
  ////////單位
  unit = "21";

  themeColor = ["pink", "skyblue", "orange", "#98FF98", "#B57EDC", "#F4C542"];

  //////////Chart Loading
  pieChartDataLoading = false;
  barChartDataLoading = false;
  lineChartDataLoading = false;
  // progressChartDataLoading = false;

  selectedDashboardPage = 0;

  //////// Chart data
  pieChartData = [];
  barChartData = []; //公司廠區排放當量(依類別劃分)和排放熱點
  lineChartData = [];
  // progressChartData = [];

  //////// mixedChart Data
  AETrackingIsLoading = true;

  intensityIsLoading = true;
  metricRecalculationPendingCount = 0;
  metricRequestVersions = new Map();
  metricCollectionVersion = 0;
  //////// AE 上部資料
  mixedChartData = { baseYear: 2020, targetYear: 2030 };
  //////// AE 下部資料
  actualData = {
    scope1: true,
    scope2: false,
    scope3: false,
    baseYear: 2020,
    targetYear: 2030,
  };

  selectedSubTab = 0;

  //////// 外部預設Scope
  defaultScope = {};

  //////// 建立新的計算機的預設值
  defaultMetricData = {};

  //////// 9個計算機的總資料
  metricData = [];

  //////// intensity 頁面是否更動
  dashboardIsEdit = false;

  //////// 顯示dashboardIsEdit警告Modal
  showDashboardWarningModal = false;

  showDeleteWarningModal = false;

  deleteIndex = null;

  standardId = "";

  pieChartUniqueId = 0;

  lineChartUniqueId = 0;

  barChartUniqueId = 0;

  //////// 在切換頁面或子頁面的時候註冊該頁面要使用的save行為
  pendingSaveHandler = null;

  constructor() {
    makeAutoObservable(this);
  }

  get isIntensityLoading() {
    return (
      this.intensityIsLoading || this.metricRecalculationPendingCount > 0
    );
  }

  _startMetricRequest = (index) => {
    const requestVersion = (this.metricRequestVersions.get(index) || 0) + 1;
    this.metricRequestVersions.set(index, requestVersion);
    this.metricRecalculationPendingCount += 1;

    return {
      requestVersion,
      collectionVersion: this.metricCollectionVersion,
    };
  };

  _isLatestMetricRequest = (index, request) =>
    request.collectionVersion === this.metricCollectionVersion &&
    this.metricRequestVersions.get(index) === request.requestVersion;

  _finishMetricRequest = () => {
    this.metricRecalculationPendingCount = Math.max(
      0,
      this.metricRecalculationPendingCount - 1,
    );
  };

  _invalidateMetricRequests = () => {
    this.metricCollectionVersion += 1;
    this.metricRequestVersions.clear();
  };

  _invalidateMetricRequest = (index) => {
    this.metricRequestVersions.set(
      index,
      (this.metricRequestVersions.get(index) || 0) + 1,
    );
  };

  ////////更新選擇類別或是範疇
  _handleSetGroupBy = (data) => {
    this.groupBy = data;
    console.log("groupBy", this.groupBy);
  };

  ////////更新選擇的公司
  _handleSetSelectedCom = (data) => {
    this.selectedCom = Array.isArray(data) ? data.filter(Boolean) : [];
    console.log("selectedCom", JSON.stringify(this.selectedCom));
  };

  ////////更新intenstiy預設的選擇公司
  _handleSetIntensityDefaultCom = (coms) => {
    this.defaultSelectedCom = Array.isArray(coms) ? coms.filter(Boolean) : [];
    console.log("defaultSelectedCom", JSON.stringify(this.defaultSelectedCom));
  };

  ////////更新選擇的年份或是月份
  _handleSetFormat = (data) => {
    this.format = data;
    // 如果選擇的是「年度」格式，則清空月份資料
    if (data === "yearly") {
      this.selectedMonth = ""; // 或設為 null，視您的程式需求而定
    } else if (data === "monthly" && !this.selectedMonth) {
      // 如果切換到「月份」格式且月份資料為空，則設定預設值
      this.selectedMonth = "1";
    }

    console.log("format", this.format);
    console.log("selectedMonth", this.selectedMonth);
  };

  /////////更新年分
  _handleSetSelectedYear = (data) => {
    this.selectedYear = data;
    console.log("selectedYear", this.selectedYear);
  };

  //////////更新standardId
  _handleSetSelectedStandardId = (data) => {
    this.standardId = data;
    console.log("standardId", this.standardId);
  };

  //////////更新月份
  _handleSetSelectedMonth = (data) => {
    this.selectedMonth = data;
    console.log("selectedMonth", this.selectedMonth);
  };

  //////////更新GwpId
  _handleSetGwpId = (data) => {
    this.gwpId = data;
    console.log("gwpId", this.gwpId);
  };

  //////////更新Unit
  _handleSetUnit = (data) => {
    this.unit = data;
    console.log("unit", this.unit);
  };

  //////////pie chart loading
  _handleSetPieChartDataLoading(value) {
    this.pieChartDataLoading = value;
  }
  //////////bar chart loading
  _handleSetBarChartDataLoading(value) {
    this.barChartDataLoading = value;
  }
  //////////line chart loading
  _handleSetLineChartDataLoading(value) {
    this.lineChartDataLoading = value;
  }
  //////////progress chart loading
  // _handleSetProgressChartDataLoading(value) {
  //   this.progressChartDataLoading = value;
  // }

  //////////pie chart data
  _handleSetPieChartData(data) {
    this.pieChartData = data;
  }

  //////////Bar chart data
  _handleSetBarChartData(data) {
    this.barChartData = data;
  }

  //////////line chart data
  _handleSetLineChartData(data) {
    this.lineChartData = data;
  }
  //////////progress chart data
  // _handleSetProgressChartData(data) {
  //   this.progressChartData = data;
  // }

  //////// 切換dashboardPage
  _handleSetSelectedDashboardPage = (page) => {
    this.selectedDashboardPage = page;
  };

  //////// 更新mixedChartData
  _handleSetMixedChartData = (key, value, reset = false) => {
    if (reset === true) {
      this.mixedChartData = {
        baseYear: 2020,
        targetYear: 2030,
      };
      console.log(JSON.stringify(this.mixedChartData));
      return;
    }

    ////////判斷baseYear targetYear大小
    if (key === "targetYear" && value <= this.mixedChartData.baseYear) {
      return {
        ok: false,
        error: "Target year must be greater than base year",
      };
    }

    if (key === "baseYear" && value >= this.mixedChartData.targetYear) {
      return {
        ok: false,
        error: "Base year must be less than target year",
      };
    }

    this.mixedChartData[key] = value;
    return { ok: true };
  };

  //////// 更新actualData
  _handleSetActualData = (key, value, reset = false) => {
    // =========== Reset 邏輯 ===========
    if (reset === true) {
      this.actualData = {
        scope1: true,
        scope2: false,
        scope3: false,
        baseYear: 2020,
        targetYear: 2030,
      };
      this.getDecarbonData();
      return;
    }

    const isScopeKey = ["scope1", "scope2", "scope3"].includes(key);
    const prevValue = this.actualData[key];

    // =========== 確保至少保持一個 true ===========
    if (isScopeKey && value === false) {
      const { scope1, scope2, scope3 } = this.actualData;

      const onlyOneTrue =
        (key === "scope1" && scope1 === true && !scope2 && !scope3) ||
        (key === "scope2" && scope2 === true && !scope1 && !scope3) ||
        (key === "scope3" && scope3 === true && !scope1 && !scope2);

      if (onlyOneTrue) {
        // 使用者取消唯一的 true → 讓它變 false，同時開啟 scope1
        this.actualData[key] = false;
        this.actualData.scope1 = true;
        console.log(
          "force scope1 true after cancelling last:",
          JSON.stringify(this.actualData),
        );

        // 這次操作確實變化 → 需要重抓資料
        this.getDecarbonData();
        return;
      }
    }

    // =========== 正常更新 ===========
    this.actualData[key] = value;

    // =========== Scope 有變化 → 重抓資料 ===========
    if (isScopeKey && prevValue !== value) {
      this.getDecarbonData();
    }
  };

  //////// 更新AETracking Actual Input
  // dashboardStore.js

  _handleUpdateActualValueByYear = (year, newValue) => {
    const targetYear = year;
    const nextValue = newValue;
    const nextArr = this.actualData?.data?.map((item) =>
      item.year === targetYear ? { ...item, value: nextValue } : item,
    );

    this.actualData.data = nextArr;
    console.log("更新後 actualData =", JSON.stringify(this.actualData));
  };

  //////// 更新subTab
  _handleSetSelectedSubTab = (selectedTab) => {
    this.selectedSubTab = selectedTab;
  };

  //////// 清空metric
  _handleClearMetric = () => {
    this.metricData = [];
  };

  ////////單一計算機呼叫API更新 總計算機資料下該單一計算機的資料
  _handleUpdateMetricByIndex = (index, newData) => {
    this.metricData[index] = newData;
    console.log("透過API更新後的metric :", JSON.stringify(this.metricData));
  };

  ////////總計算機更新特定index key
  _handleUpdateMetricByField = (index, key, value) => {
    console.log(index);
    this.metricData[index][key] = value;
    console.log("透過index key更新的metric :", JSON.stringify(this.metricData));
  };

  ////////總計算機更新特定Scope

  ////////總計算機更新特定的Year資料
  _handleUpdateYearValue = (index, type, yearIndex, newValue) => {
    this.metricData[index][type][yearIndex].value = newValue;
    console.log("更新年度資料的metric :", JSON.stringify(this.metricData));
  };

  //////// 刪除特定的metric
  _handleDeleteMetricByIndex = async (index) => {
    if (index < 0 || index >= this.metricData.length) {
      console.warn("deleteMetricByIndex: index 超出範圍");
      return;
    }

    const computerId = this.metricData[index]["computerId"];
    this._invalidateMetricRequests();
    this.metricData.splice(index, 1);

    if (computerId !== "Default") {
      this.intensityIsLoading = true;
      await API.deleteIntensity(cmStore.userId, computerId);
      await this.getAllIntensityData();
      this.intensityIsLoading = false;
    }
  };

  //////// 新增一筆 metric ( 限制最多9筆 )
  _handleCreateMetric = async () => {
    if (this.metricData.length >= 9) return false;

    const companyIds = [...this.selectedCom];
    if (companyIds.length === 0) {
      showErrorToast({
        i18nKey: "Please select at least one company for each metric.",
        ns: "System",
        fallback: "Please select at least one company for each metric.",
      });
      return false;
    }

    const baseYear = this.mixedChartData.baseYear;
    const targetYear = this.mixedChartData.targetYear;
    const gwpId = this.gwpId;

    this.intensityIsLoading = true;
    try {
      const scopeResponse = await API.getDefaultScope({
        userId: cmStore.userId,
        scope1: true,
        scope2: true,
        scope3: true,
        companyIds,
        baseYear,
        targetYear,
        gwpId,
        computerId: "",
      });

      const scopes = scopeResponse?.[0];
      if (!scopes?.scope1 || !scopes?.scope2 || !scopes?.scope3) {
        throw new Error("Metric scope response is invalid");
      }

      return this._createMetricFromDefaultData({
        companyIds,
        scopes: JSON.parse(JSON.stringify(scopes)),
        baseYear,
        targetYear,
        gwpId,
      });
    } catch (err) {
      handleAPIError(err, {
        throwError: false
      });
      return false;
    } finally {
      this.intensityIsLoading = false;
    }
  };

  _createMetricFromDefaultData = ({
    companyIds,
    scopes,
    baseYear,
    targetYear,
    gwpId,
  }) => {
    if (this.metricData.length >= 9) {
      console.warn("最多只能新增 9 個 metric");
      return false;
    }

    // 深拷貝 defaultMetricData
    const newMetric = {
      ...JSON.parse(JSON.stringify(this.defaultMetricData)),
      companyIds,
      scopes,
      baseYear,
      targetYear,
      gwpId,
    };

    this.metricData.push(newMetric);
    this.dashboardIsEdit = true;

    console.log("新增後 metricData:", JSON.stringify(this.metricData));
    return true;
  };

  _handleSetDashboardIsEdit = (state) => {
    this.dashboardIsEdit = state;
  };

  _handleSetShowDashboardWarningModal = (state) => {
    this.showDashboardWarningModal = state;
  };

  _handleSetShowDeleteWarningModal = (state) => {
    this.showDeleteWarningModal = state;
  };

  _handleSetDeleteIndex = (idx) => {
    this.deleteIndex = idx;
  };

  ////////不同頁面在有更動前要註冊的save行為
  registerSaveHandler(fn) {
    this.pendingSaveHandler = fn;
  }

  ////////清空頁面註冊的save行為
  clearSaveHandler() {
    this.pendingSaveHandler = null;
  }

  ////////呼叫註冊的save行為
  async executeSaveHandler() {
    if (this.pendingSaveHandler) {
      return await this.pendingSaveHandler();
    }
    return true;
  }

  ////////把答案轉回year取得
  get actualDataMap() {
    const data = this.actualData.data || [];
    // 轉換成 { year: value } 的映射表
    return data.reduce((map, item) => {
      if (item && item.year) {
        // 確保我們存儲的是 MobX 觀察到的值
        map[item.year] = item.value;
      }
      return map;
    }, {});
  }

  ///////取得年度的資料
  getPieChartData = async () => {
    this._handleSetPieChartDataLoading(true);
    this._handleSetPieChartData([]);
    let uniqueId = this.pieChartUniqueId + 1;
    this.pieChartUniqueId += 1;
    try {
      //去呼叫後端API
      const data = await API.PieChartDataAPI(
        this.selectedCom,
        this.selectedYear,
        this.selectedMonth,
        this.gwpId,
        this.unit,
        this.standardId,
      );
      // console.log("Pie chart是：", data);
      ////////拿取資料

      if (uniqueId === this.pieChartUniqueId) {
        this._handleSetPieChartData(data);
      }
    } catch (error) {
      console.error("Error fetching pie chart list", error);
      this._handleSetPieChartData([]);
    } finally {
      if (uniqueId === this.pieChartUniqueId) {
        this._handleSetPieChartDataLoading(false);
      }
    }
  };

  getLineChartData = async () => {
    this._handleSetLineChartDataLoading(true);
    this._handleSetLineChartData([]);
    let uniqueId = this.lineChartUniqueId + 1;
    this.lineChartUniqueId += 1;
    try {
      //去呼叫後端API
      const data = await API.LineChartDataAPI(
        this.selectedCom,
        this.selectedYear,
        this.selectedMonth,
        this.gwpId,
        this.unit,
        this.standardId,
      );
      console.log("Line chart是：", data);
      ////////拿取資料

      if (uniqueId === this.lineChartUniqueId) {
        this._handleSetLineChartData(data);
      }
    } catch (error) {
      console.error("Error fetching line chart list", error);
      this._handleSetLineChartData([]);
    } finally {
      if (uniqueId === this.lineChartUniqueId) {
        this._handleSetLineChartDataLoading(false);
      }
    }
  };

  getBarChartData = async () => {
    this._handleSetBarChartDataLoading(true);
    this._handleSetBarChartData([]);
    let uniqueId = this.barChartUniqueId + 1;
    this.barChartUniqueId += 1;
    try {
      //去呼叫後端API
      const data = await API.BarChartDataAPI(
        this.selectedCom,
        this.selectedYear,
        this.selectedMonth,
        this.gwpId,
        this.unit,
        this.standardId,
      );
      console.log("Bar chart是：", data);
      ////////拿取資料
      if (uniqueId === this.barChartUniqueId) {
        this._handleSetBarChartData(data);
      }
    } catch (error) {
      console.error("Error fetching bar chart list", error);
      this._handleSetBarChartData([]);
    } finally {
      if (uniqueId === this.barChartUniqueId) {
        this._handleSetBarChartDataLoading(false);
      }
    }
  };

  //////// 取得減碳頁面的排放資料
  getDecarbonData = async () => {
    this.AETrackingIsLoading = true;
    try {
      const userInputData =
        (await API.getDecarbonSetting({
          userId: cmStore.userId,
          baseYear: this.mixedChartData.baseYear,
          targetYear: this.mixedChartData.targetYear,
          companyIds: this.selectedCom,
          baseEmission: this.mixedChartData.baseEmission || 0,
          annualReductionRate: this.mixedChartData.annualReductionRate || 0,
        })) || {};

      if (Object.keys(userInputData).length > 0) {
        this.mixedChartData = userInputData;
        console.log(JSON.stringify(this.mixedChartData));
      }

      const yearEmissionData = await API.getDecarbonYearEmission({
        userId: cmStore.userId,
        scope1: this.actualData.scope1,
        scope2: this.actualData.scope2,
        scope3: this.actualData.scope3,
        companyIds: this.selectedCom,
        baseYear: this.mixedChartData.baseYear,
        targetYear: this.mixedChartData.targetYear,
        gwpId: Number(this.gwpId),
      });

      if (yearEmissionData?.data.length > 0) {
        this.actualData.data = formatNumber4Decimal(yearEmissionData.data);
        this.actualData.lock = yearEmissionData.systemYears;
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.AETrackingIsLoading = false;
    }
  };

  //////// 更新減碳頁面使用者輸入基本資料
  updateDecarbonData = async () => {
    try {
      this.AETrackingIsLoading = true;
      this.dashboardIsEdit = false;
      //////// 更新減碳頁面使用者輸入基本資料 (上部)
      const settingResponse = await API.updateDecarbonSetting({
        userId: cmStore.userId,
        baseYear: this.mixedChartData.baseYear,
        targetYear: this.mixedChartData.targetYear,
        companyIds: this.selectedCom,
        baseEmission: this.mixedChartData.baseEmission || 0,
        annualReductionRate: this.mixedChartData.annualReductionRate || 0,
      });

      //////// 更新減碳頁面的排放資料 (下部)
      const normalize = (arr) =>
        arr.map((item) => ({
          ...item,
          value: item.value === "" ? null : Number(item.value),
        }));

      const normalizeData = normalize(this.actualData.data);
      const yearResponse = await API.updateDecarbonYearEmission({
        userId: cmStore.userId,
        scope1: this.actualData.scope1,
        scope2: this.actualData.scope2,
        scope3: this.actualData.scope3,
        companyIds: this.selectedCom,
        data: normalizeData,
        systemYears: this.actualData.lock,
      });

      if (!settingResponse || !yearResponse) return null;

      showSuccessToast({
        apiData: yearResponse,
        scenarioCode: MESSAGE_CODES.DASHBOARD_DECARBONIZATION_UPDATE_SUCCESS,
      });
    } catch (err) {
      console.error(err);
      return null;
    } finally {
      this.AETrackingIsLoading = false;
    }
  };

  //////// 監聽並取得default數值
  get defaultMetricAPIData() {
    return {
      userId: cmStore.userId,
      companyIds: this.selectedCom,
      baseYear: this.mixedChartData.baseYear,
      targetYear: this.mixedChartData.targetYear,
      gwpId: this.gwpId,
    };
  }

  //////// 取得計算機default Scope
  getIntensityDefaultScope = async () => {
    try {
      this.intensityIsLoading = true;

      const res = await API.getDefaultScope({
        userId: cmStore.userId,
        scope1: true,
        scope2: true,
        scope3: true,
        companyIds: this.selectedCom,
        baseYear: this.mixedChartData.baseYear,
        targetYear: this.mixedChartData.targetYear,
        gwpId: this.gwpId,
        computerId: "",
      });

      this.defaultScope = res[0];
    } catch (err) {
      console.error(err);
      return null;
    } finally {
      this.intensityIsLoading = false;
    }
  };

  //////// 取得計算機All list
  getAllIntensityData = async () => {
    try {
      this._invalidateMetricRequests();
      this.metricData = [];
      this.intensityIsLoading = true;
      const requestBody = this.defaultMetricAPIData;
      requestBody.scope1 = this.defaultScope.scope1.default;
      requestBody.scope2 = this.defaultScope.scope2.default;
      requestBody.scope3 = this.defaultScope.scope3.default;
      const res = await API.getAllIntensityData(requestBody);
      if (res.length <= 0) return;

      const defaultCompanyIds = getAllSelectableCompanyIds(
        cmStore.companyList,
      );
      this.defaultSelectedCom = defaultCompanyIds;
      this.defaultgwpId = 3;

      //////// 賦予defaultData
      this.defaultMetricData = {
        ...res[res.length - 1],
        scopes: this.defaultScope,
        companyIds: [...defaultCompanyIds],
        gwpId: 3,
        actualByYear: formatNumber4Decimal(
          res[res.length - 1].actualByYear || [],
        ),
        denominatorByYear: formatNumber4Decimal(
          res[res.length - 1].denominatorByYear || [],
        ),
      };

      // ===== metricData
      this.metricData = res.slice(0, -1).map((item) => ({
        ...item,
        scopes: this.defaultScope,
        companyIds: [...defaultCompanyIds],
        gwpId: 3,
        actualByYear: formatNumber4Decimal(item.actualByYear || []),
        denominatorByYear: formatNumber4Decimal(item.denominatorByYear || []),
      }));
    } catch (err) {
      console.error(err);
      return null;
    } finally {
      this.intensityIsLoading = false;
    }
  };

  //////// 更新計算機資料
  updateIntensityData = async () => {
    const hasMetricWithoutCompany = this.metricData.some(
      (metric) =>
        !Array.isArray(metric.companyIds) || metric.companyIds.length === 0,
    );

    if (hasMetricWithoutCompany) {
      showErrorToast({
        i18nKey: "Please select at least one company for each metric.",
        ns: "System",
        fallback: "Please select at least one company for each metric.",
      });
      return false;
    }

    this.intensityIsLoading = true;
    try {
      const cleanedData = this.metricData.map((m) => ({
        ...m,
        actualByYear: strToNum(m.actualByYear || []),
        denominatorByYear: strToNum(m.denominatorByYear || []),
      }));
      const isSaved = await API.updateIntensityData(cleanedData);
      if (!isSaved) {
        throw new Error("Metric update failed");
      }

      this.dashboardIsEdit = false;
      await this.getAllIntensityData();
      return true;
    } catch (err) {
      handleAPIError(err, {
        throwError: false
      });
      return false;
    } finally {
      this.intensityIsLoading = false;
    }
  };

  //////// 取得單一筆計算機資料並覆蓋 (當Entity 與Scope被改變的同時)
  updateSingleIntensityData = async (card, index) => {
    if (!Array.isArray(card.companyIds) || card.companyIds.length === 0) {
      this._invalidateMetricRequest(index);
      if (this.metricData[index]) {
        this.metricData[index].actualByYear = [];
      }
      return false;
    }

    const request = this._startMetricRequest(index);
    try {
      //////// 取得單一筆的特定Scope
      const scopeData = await API.getDefaultScope({
        userId: cmStore.userId,
        scope1: card.scopes.scope1.default,
        scope2: card.scopes.scope2.default,
        scope3: card.scopes.scope3.default,
        companyIds: card.companyIds,
        baseYear: card.baseYear,
        targetYear: card.targetYear,
        gwpId: card.gwpId,
        computerId: card.computerId,
      });

      if (!this._isLatestMetricRequest(index, request)) return false;
      if (!scopeData?.[0]) {
        throw new Error("Metric scope response is invalid");
      }

      //////// 使用剛更新的Scope拿單一筆計算機的資料並覆蓋
      const singleRes = await API.getAllIntensityData({
        userId: cmStore.userId,
        scope1: scopeData[0].scope1.default,
        scope2: scopeData[0].scope2.default,
        scope3: scopeData[0].scope3.default,
        companyIds: card.companyIds,
        baseYear: card.baseYear,
        targetYear: card.targetYear,
        gwpId: card.gwpId,
        computerId: card.computerId,
      });

      if (!this._isLatestMetricRequest(index, request)) return false;
      const singleData = singleRes?.[0];
      if (!singleData) {
        throw new Error("Metric response is invalid");
      }

      if (this._isLatestMetricRequest(index, request)) {
        const normalizedSingleData = {
          ...singleData,
          companyIds: card.companyIds,
          scopes: card.scopes,
          gwpId: card.gwpId,
          actualByYear: formatNumber4Decimal(singleData.actualByYear || []),
          denominatorByYear: formatNumber4Decimal(
            singleData.denominatorByYear || [],
          ),
        };

        this._handleUpdateMetricByIndex(index, normalizedSingleData);
      }
      return true;
    } catch (err) {
      if (this._isLatestMetricRequest(index, request)) {
        if (this.metricData[index]) {
          this.metricData[index].actualByYear = [];
        }
        handleAPIError(err, {
          throwError: false
        });
      }
      return false;
    } finally {
      this._finishMetricRequest();
    }
  };

  //////// 當scope被改變時覆蓋
  updateSingleIntensityDataByScope = async (card, index) => {
    if (!Array.isArray(card.companyIds) || card.companyIds.length === 0) {
      this._invalidateMetricRequest(index);
      if (this.metricData[index]) {
        this.metricData[index].actualByYear = [];
      }
      return false;
    }

    const request = this._startMetricRequest(index);
    try {
      const res = await API.getAllIntensityData({
        userId: cmStore.userId,
        scope1: card.scopes.scope1.default,
        scope2: card.scopes.scope2.default,
        scope3: card.scopes.scope3.default,
        companyIds: card.companyIds,
        baseYear: card.baseYear,
        targetYear: card.targetYear,
        gwpId: card.gwpId,
        computerId: card.computerId,
      });

      if (!this._isLatestMetricRequest(index, request)) return false;
      const singleData = res?.[0];

      if (!singleData) {
        throw new Error("Metric response is invalid");
      }

      if (this._isLatestMetricRequest(index, request)) {
        const normalizedSingleData = {
          ...singleData,
          companyIds: card.companyIds,
          scopes: card.scopes,
          gwpId: card.gwpId,
          actualByYear: formatNumber4Decimal(singleData.actualByYear || []),
          denominatorByYear: formatNumber4Decimal(
            singleData.denominatorByYear || [],
          ),
        };

        this._handleUpdateMetricByIndex(index, normalizedSingleData);
      }
      return true;
    } catch (err) {
      if (this._isLatestMetricRequest(index, request)) {
        if (this.metricData[index]) {
          this.metricData[index].actualByYear = [];
        }
        handleAPIError(err, {
          throwError: false
        });
      }
      return false;
    } finally {
      this._finishMetricRequest();
    }
  };
}

const dashboardStore = new DashboardStore();
export default dashboardStore;
